export default {
  meta: {
    title: '门店地图',
    url: '/selection/store', // 埋点用，记录所属模块
    // eventId: 'bb899bbc-806a-416a-a544-6bd97211b801'
  },
};
